import Vue from "vue";
import Vuex from "vuex";

import androidbanners from "./android_banners";
import ambismeter from "../../ambis_meter/stores/ambis_meter";
import auth from "../../auth/stores/auth";
import bimbel from "../../bimbel_online/stores/bimbel";
import datatable from "./datatable";
import datatablecontent from "./datatablecontent";
import error from "./error";
import info from "../../ambis_meter/stores/info";
import iosbanners from "./ios_banners";
import landingbanners from "./landing_banners";
import landingpackages from "./landing_packages";
import liveclass from "../../live_class/stores/liveclass";
import quote from "../../ambis_meter/stores/quote";
import liveclassteacher from "../../live_class_teacher/stores/liveclassteacher";
import tryout from "../../tryout/stores/tryout";
import tryoutgroup from "../../tryout_group/stores/tryout_group";
import usman from "../../usman/stores/usman";
import video from "../../vd_pembelajaran/stores/video";
import webappbanners from "./webapp_banners";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        androidbanners,
        ambismeter,
        auth,
        bimbel,
        datatable,
        error,
        info,
        iosbanners,
        landingbanners,
        landingpackages,
        liveclass,
        quote,
        liveclassteacher,
        tryout,
        tryoutgroup,
        usman,
        video,
        webappbanners,
    },
});



// WEBPACK FOOTER //
// ./src/modules/global/stores/index.js